import clsx from 'clsx';

import styles from './Tabs.module.css';

export interface TabItem<T extends string> {
  readonly id: T;
  readonly label: string;
  readonly count?: number;
  readonly disabled?: boolean;
}

export interface TabsProps<T extends string> {
  readonly items: readonly TabItem<T>[];
  readonly active: T;
  readonly onChange: (id: T) => void;
  readonly label: string;
}

/** Generic tab strip. Callers own the panel rendering. */
export function Tabs<T extends string>({ items, active, onChange, label }: TabsProps<T>) {
  return (
    <div className={styles.tabs} role="tablist" aria-label={label}>
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          role="tab"
          aria-selected={item.id === active}
          disabled={item.disabled}
          className={clsx(styles.tab, item.id === active && styles.active)}
          onClick={() => {
            onChange(item.id);
          }}
        >
          {item.label}
          {item.count !== undefined && <span className={styles.count}>({item.count})</span>}
        </button>
      ))}
    </div>
  );
}
